import { render, staticRenderFns } from "./ViewTrip.vue?vue&type=template&id=2e1ce1e6&scoped=true"
import script from "./ViewTrip.vue?vue&type=script&lang=js"
export * from "./ViewTrip.vue?vue&type=script&lang=js"
import style0 from "./ViewTrip.vue?vue&type=style&index=0&id=2e1ce1e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ce1e6",
  null
  
)

export default component.exports